"use client";

import { cn } from "@/lib/utils";
import { CommunityImage } from "./CommunityImage";
import type { PublicCommunityShop } from "@/lib/community/types";

interface ShopAvatarProps {
  shop: Pick<PublicCommunityShop, "name" | "logo_url">;
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "default" | "store";
  className?: string;
}

const sizeClasses = {
  sm: "w-8 h-8 text-xs",
  md: "w-12 h-12 text-sm",
  lg: "w-16 h-16 text-base",
  xl: "w-24 h-24 text-xl",
};

export function ShopAvatar({
  shop,
  size = "md",
  variant = "default",
  className,
}: ShopAvatarProps) {
  const initials = (shop.name ?? "").slice(0, 2).toUpperCase() || "??";
  const isStore = variant === "store";

  if (shop.logo_url) {
    return (
      <CommunityImage
        src={shop.logo_url}
        alt={shop.name ?? "Shop"}
        width={size === "xl" ? 96 : size === "lg" ? 64 : size === "md" ? 48 : 32}
        height={size === "xl" ? 96 : size === "lg" ? 64 : size === "md" ? 48 : 32}
        className={cn(
          "rounded-full object-contain bg-white border border-primary-500",
          isStore &&
            "border-2 shadow-[0_0_20px_rgba(34,197,94,0.35)]",
          sizeClasses[size],
          className,
        )}
      />
    );
  }

  return (
    <div
      className={cn(
        "rounded-full bg-brand-green-soft text-brand-green flex items-center justify-center font-semibold border border-primary-500",
        isStore &&
          "border-2 shadow-[0_0_20px_rgba(34,197,94,0.35)]",
        sizeClasses[size],
        className,
      )}
    >
      {initials}
    </div>
  );
}
